module.exports = __webpack_public_path__ + "img/menu.fef35574.svg";